import { render, staticRenderFns } from "./OncologiaEscalas.vue?vue&type=template&id=24e645e9"
import script from "./OncologiaEscalas.vue?vue&type=script&lang=js"
export * from "./OncologiaEscalas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports